module.exports = __webpack_public_path__ + "static/media/metro.bc3db359.png";